import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { About, IStrapiDocument } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { NgIf, NgFor } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [
        BreadcrumbsComponent,
        NgIf,
        PageRetrievalErrorComponent,
        NgFor,
        RenderMarkdownComponent,
    ],
})
export class AboutComponent extends PageComponent implements OnInit {
  public override pageData: About = <About>{};

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentsByType('about', {
        populate: {
          about_sections: { populate: '*' },
          banner_image: true,
        },
      })
      .subscribe({
        next: (data: IStrapiDocument<About>) => {
          this.parsePageData(data.data.attributes);
          super.setMetas();
          this.cdr.markForCheck();
        },
        error: () => {
          this.pageRetrievalError = true;
          this.cdr.markForCheck();
        },
      });
  }

  protected override parsePageData(page: About): void {
    super.parsePageData(page);

    this.pageData = page;
  }

  public toggleAboutSection(e: Event): void {
    e.stopPropagation();
    e.preventDefault();

    const el = <HTMLElement>e.target; // the heading
    const parent = <HTMLElement>el.parentElement; // the section div

    // if it's already visible, just remove the class
    if (parent.classList.contains('about-section-show')) {
      parent.classList.remove('about-section-show');
    } else {
      // want to show it, all others must be hidden
      this.hideAllAboutSections();
      parent.classList.add('about-section-show');
    }
  }

  private hideAllAboutSections(): void {
    const visibleSections = document.querySelectorAll('.about-section-show');
    [].forEach.call(visibleSections, (el: HTMLElement) => {
      el.classList.remove('about-section-show');
    });
  }
}
